import { HTMLAttributes } from 'react';

export default function Card({ className = '', children, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div {...props} className={'mx-auto max-w-full space-y-6 sm:px-6 ' + className}>
            <div className="bg-gray-50 p-4 py-3 shadow sm:rounded-lg sm:px-6">{children}</div>
        </div>
    );
}